import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Select,
  TextField,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { ExpandMore } from '@mui/icons-material';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import { useHook as equipmentInfo } from './useHook';
import DoneIcon from '@mui/icons-material/Done';
interface FilterDrawer {
  fliterCloseDrawer: () => void;
  filterSubmit: (data: any) => void;
  filterDrawerData?: any;
}

const EquimentFilter: React.FC<FilterDrawer> = ({
  fliterCloseDrawer,
  filterSubmit,
  filterDrawerData,
}) => {
  const { fetchGetEquipmentFilter } = equipmentInfo();
  const [dealerCategory, setDealerCategory] = React.useState<string[]>([]);
  const [dealerSubcategory, setDealerSubcategory] = React.useState<string[]>(
    [],
  );
  const [filteredCategory, setFilteredCategory] = useState<any[]>([]);
  const [filteredSubCategory, setFilteredSubCategory] = useState<any[]>([]);
  const [isFilterActive, setFilterActive] = useState(false);
  const { equipmentFilterList } = useSelector(
    (state: any) => state.equipmetInfo,
  );
  const [openCategory, setOpenCategory] = useState(false);
  const [openSubCategory, setOpenSubCategory] = useState(false);
  const [filterStoreCategory, setFilterStoreCategory] = useState<any[]>([]);
  const [filterStoreSubCategory, setFilterStoreSubCategory] = useState<any[]>(
    [],
  );

  //get Category
  const handleGetCategory = () => {
    const updateCategory = equipmentFilterList?.category?.map(
      (data: { categoryName: any }) => data?.categoryName,
    );
    setFilteredCategory(updateCategory ? updateCategory : []);
    setFilterStoreCategory(updateCategory ? updateCategory : []);
  };
  //get SubCategory
  const handleGetSubCategory = async () => {
    // Filter based on exact match for the category name
    const upDateSubCategory = equipmentFilterList?.category
      ?.filter(
        (category: { categoryName: any; subCategories: any }) =>
          dealerCategory.includes(category.categoryName) &&
          Array.isArray(category.subCategories),
      )
      .flatMap((category: { subCategories: any }) => category.subCategories);
    setFilteredSubCategory(upDateSubCategory ? upDateSubCategory : []);
    setFilterStoreSubCategory(upDateSubCategory ? upDateSubCategory : []);

    //subCategory selection values
    const selectSubCategory = upDateSubCategory?.filter((data: string) =>
      dealerSubcategory?.includes(data),
    );
    setDealerSubcategory(selectSubCategory ? selectSubCategory : []);
  };
  useEffect(() => {
    handleGetSubCategory();
  }, [dealerCategory]);

  useEffect(() => {
    if (equipmentFilterList?.category?.length > 0) {
      handleGetCategory();
    }
  }, [equipmentFilterList]);

  useEffect(() => {
    if (filterDrawerData) {
      setDealerSubcategory(filterDrawerData?.subCategory);
      setDealerCategory(filterDrawerData?.category);
    }
  }, [filterDrawerData]);

  useEffect(() => {
    if (
      !equipmentFilterList ||
      Object.keys(equipmentFilterList)?.length === 0
    ) {
      fetchGetEquipmentFilter();
    }
  }, []);

  const handleCategorySearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query = event.target.value.toLowerCase();
    const filtered = filterStoreCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredCategory(filtered);
  };

  useEffect(() => {
    const isFilterActive =
      dealerCategory?.length > 0 || dealerSubcategory?.length > 0;

    setFilterActive(isFilterActive);
  }, [dealerCategory, dealerSubcategory]);

  const handleFilterSelection = (
    selectName: string | undefined,
    field: string,
  ) => {
    if (!selectName) return;
    else if (field === 'category') {
      setDealerCategory((prevselected) => {
        if (prevselected.includes(selectName)) {
          // const updatedData = prevselected.filter(
          //   (names) => names !== selectName,
          // );
          // return updatedData;
          return [];
        } else {
          const updatedData = [selectName];
          return updatedData;
        }
      });
      setOpenCategory(false);
    } else if (field === 'subCategory') {
      setDealerSubcategory((prevselected) => {
        if (prevselected.includes(selectName)) {
          // const updatedData = prevselected.filter(
          //   (names) => names !== selectName,
          // );
          // return updatedData;
          return [];
        } else {
          const updatedData = [selectName];
          return updatedData;
        }
      });
      setOpenSubCategory(false);
    }
  };

  const handleSubCategorySearch = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const query = event.target.value.toLowerCase();
    const filtered = filterStoreSubCategory?.filter((category: string) =>
      category?.toLowerCase().includes(query),
    );
    setFilteredSubCategory(filtered);
  };

  const handleFilterEquipment = () => {
    const payload = {
      category: dealerCategory,
      subcategory: dealerSubcategory,
    };
    filterSubmit(payload);
  };

  //CancelFilter
  const handleCancelCategoryFilter = () => {
    setDealerCategory(filterDrawerData ? filterDrawerData?.category : []);
    setOpenCategory(false);
    // setFilteredCategory(equipmentFilterList?.category);
    handleGetCategory();
  };
  const handleCancelSubCategoryFilter = () => {
    // setFilteredSubCategory(equipmentFilterList?.subCategory);
    handleGetSubCategory();
    setDealerSubcategory(filterDrawerData ? filterDrawerData?.subCategory : []);
    setOpenSubCategory(false);
  };
  //apply filter
  const handleApplyFilter = () => {
    setOpenCategory(false);
    setOpenSubCategory(false);
    // setFilteredCategory(equipmentFilterList?.category);
    // setFilteredSubCategory(equipmentFilterList?.subCategory);
    handleGetCategory();
    handleGetSubCategory();
  };
  return (
    <div className="fliter-drawer-container">
      <div>
        <div className="fliter-drawer-header">
          <p className="fliter-drawer-header-content">Fliters</p>
          {/* <p className="fliter-drawer-header-text">Restore</p> */}
        </div>
        <div className="fliter-drawer-body">
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Category</p>
            <Select
              open={openCategory}
              onOpen={() => setOpenCategory(true)}
              className="create_controller-nodata_drawer_form_field_input"
              multiple
              displayEmpty
              value={dealerCategory}
              onClose={() => {
                setOpenCategory(false);
                handleGetCategory();
              }}
              renderValue={() => {
                if (dealerCategory?.length === 0 || !dealerCategory) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Category
                    </span>
                  );
                }
                return dealerCategory?.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height user_name-popover">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search category here"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredCategory?.map((category, index) => (
                    <Button
                      key={index}
                      onClick={() => {
                        handleFilterSelection(String(category), 'category');
                      }}
                      className={
                        dealerCategory.includes(String(category))
                          ? 'global_audilog_user user_checked'
                          : 'global_audilog_user'
                      }
                    >
                      <div className="global_audilog_user_profile">
                        <p>{category}</p>
                      </div>
                      {dealerCategory.includes(String(category)) && (
                        <IconButton className="iconButton">
                          <DoneIcon className="doneIcon" />
                        </IconButton>
                      )}
                    </Button>
                    // <div key={index} className="selectoption_list">
                    //   <FormControlLabel
                    //     control={
                    //       <Checkbox
                    //         checked={dealerCategory.includes(String(category))}
                    //         onChange={() => {
                    //           handleFilterSelection(
                    //             String(category),
                    //             'category',
                    //           );
                    //         }}
                    //       />
                    //     }
                    //     label={category}
                    //   />
                    // </div>
                  ))}
                </div>
              </div>
              {/* <div className="select_dropdown-btn">
                <Button
                  className="select_dropdown-cancel-btn"
                  onClick={handleCancelCategoryFilter}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleApplyFilter}
                  className="select_dropdown-btn"
                >
                  Apply
                </Button>
              </div> */}
            </Select>
          </div>
          <div className="fliter-drawer-body-content">
            <p className="fliter-drawer-body-lable">Subcategory</p>
            <Select
              open={openSubCategory}
              onOpen={() => setOpenSubCategory(true)}
              className="create_controller-nodata_drawer_form_field_input"
              disabled={filterStoreSubCategory?.length == 0}
              multiple
              displayEmpty
              value={dealerSubcategory}
              onClose={() => {
                setOpenSubCategory(false);
                handleGetSubCategory();
              }}
              renderValue={() => {
                if (dealerSubcategory?.length === 0 || !dealerSubcategory) {
                  return (
                    <span className="filter_dropdown_placeholder_text">
                      Subcategory
                    </span>
                  );
                }
                return dealerSubcategory?.join(', ');
              }}
              IconComponent={ExpandMore}
            >
              <div className="selectoption_content filter_dropdown-height  user_name-popover">
                <div className="selectoption_search_content">
                  <TextField
                    className="selectoption_searchbar search-input"
                    variant="outlined"
                    placeholder="Search subcategory here"
                    fullWidth
                    InputProps={{
                      startAdornment: <SearchIcon className="search_icon" />,
                    }}
                    onChange={handleSubCategorySearch}
                  />
                </div>
                <div className="selectoption_list_content">
                  {filteredSubCategory?.map((subCategory, index) => (
                    <Button
                      key={index}
                      onClick={() => {
                        handleFilterSelection(
                          String(subCategory),
                          'subCategory',
                        );
                      }}
                      className={
                        dealerSubcategory.includes(String(subCategory))
                          ? 'global_audilog_user user_checked'
                          : 'global_audilog_user'
                      }
                    >
                      <div className="global_audilog_user_profile">
                        <p>{subCategory}</p>
                      </div>
                      {dealerSubcategory.includes(String(subCategory)) && (
                        <IconButton className="iconButton">
                          <DoneIcon className="doneIcon" />
                        </IconButton>
                      )}
                    </Button>

                    // <div key={index} className="selectoption_list">
                    //   <FormControlLabel
                    //     control={
                    //       <Checkbox
                    //         checked={dealerSubcategory.includes(
                    //           String(subCategory),
                    //         )}
                    //         onChange={() => {
                    //           handleFilterSelection(
                    //             String(subCategory),
                    //             'subCategory',
                    //           );
                    //         }}
                    //       />
                    //     }
                    //     label={subCategory}
                    //   />
                    // </div>
                  ))}
                </div>
              </div>
              {/* <div className="select_dropdown-btn">
                <Button
                  className="select_dropdown-cancel-btn"
                  onClick={handleCancelSubCategoryFilter}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleApplyFilter}
                  className="select_dropdown-btn"
                >
                  Apply
                </Button>
              </div> */}
            </Select>
          </div>
        </div>
      </div>
      <div className="create_controller-nodata_drawer_button_content">
        <div className="create_controller-nodata_drawer_button">
          <Button
            variant="text"
            className="cencel_button"
            onClick={fliterCloseDrawer}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleFilterEquipment}
            className={
              isFilterActive ? 'save_button' : 'save_button disabled_button'
            }
            disabled={!isFilterActive}
          >
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export default EquimentFilter;
